module.exports = __webpack_public_path__ + "static/media/logo-ilia.f86c66f3.svg";